import { ActionTree } from 'vuex'
import { RootState } from '@/store/types'
import { WorkFileTrackingState } from './types';

export const actions: ActionTree<WorkFileTrackingState, RootState> = {
  reset({ commit }) {
    commit('identification/CLEAR')
    commit('RESET')
    commit('appointment/CLEAR')
  }
}
